import { render, staticRenderFns } from "./cmptRule.vue?vue&type=template&id=49c56b66&"
import script from "./cmptRule.vue?vue&type=script&lang=js&"
export * from "./cmptRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports